export class SearchHomePageProductBreakdownRequest {
    ProductID: number[];
    OnlyYard: boolean;
}
